import { DownloadOutlined } from '@ant-design/icons';
import { useLazyGetPdfQuery } from '@src/services/order/orderApiSlice';
import { Button } from 'antd';

const DownloadInvoiceButton: React.FC<{ orderId: string }> = ({ orderId }) => {
  const [getInvoice, { isLoading }] = useLazyGetPdfQuery();

  const onClick = async () => {
    try {
      const result = await getInvoice({ id: orderId }).unwrap();

      if (result?.downloadUrl) {
        window.open(result.downloadUrl, '_blank');
      }
    } catch (error) {
      console.error('Failed to download invoice', error);
    }
  };

  return (
    <Button
      loading={isLoading}
      onClick={onClick}
      color='blue'
      className='flex gap-2 bg-theme-infoContainerLight-light text-blue-600 px-2 border-none'
    >
      {<DownloadOutlined />}
      <p className='max-sm:hidden'>Download</p>
    </Button>
  );
};

export default DownloadInvoiceButton;
